module.exports = __webpack_public_path__ + "static/media/ar.4d1c3636.svg";